import React from "react";
import { Container, Card, Button } from "react-bootstrap";
import { FaSadTear, FaShoppingBag } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const NoProducts = () => {
    const navigate = useNavigate();
  return (
    <Container className="d-flex justify-content-center py-4" style={{ minHeight: "40vh" }}>
      <Card 
        className="text-center shadow-sm my-4 p-4 justify-content-center align-items-center"
        style={{ maxWidth: "450px", borderRadius: "16px" }}
      >
        <FaSadTear size={50} color="#b02a30" className="text-center"/>

        <h5 className="mt-3" style={{ fontWeight: 600 }}>
          No products found
        </h5>

        <p className="text-muted mt-2" style={{ lineHeight: 1.6 }}>
          Nothing to see here yet — but new treasures arrive all the time.
        </p>

        <Button 
          variant="danger" 
          className="mt-4 px-4 py-2"
          style={{ borderRadius: "10px" }}
          onClick={()=>navigate("/")}
        >
          Explore
        </Button>
      </Card>
    </Container>
  );
};

export default NoProducts;
